export const getTabs = (): { label: string; name: string }[] => {
  return [
    { label: "Nierozpoczęty", name: "not-started" },
    { label: "W toku", name: "in-progress" },
    { label: "Zakończone", name: "finished" },
    { label: "Wszystkie", name: "all" },
  ];
};
